import * as React from "react";

const LocationIcon2 = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#000"
      d="M10 5a3.125 3.125 0 1 0 0 6.25A3.125 3.125 0 0 0 10 5Zm0 5a1.875 1.875 0 1 1 0-3.75A1.875 1.875 0 0 1 10 10Zm0-8.75a6.883 6.883 0 0 0-6.875 6.875c0 2.453 1.134 5.053 3.281 7.52a19.859 19.859 0 0 0 3.239 2.992.625.625 0 0 0 .717 0 19.854 19.854 0 0 0 3.232-2.992c2.144-2.467 3.281-5.067 3.281-7.52A6.883 6.883 0 0 0 10 1.25Zm0 16.094c-1.291-1.016-5.625-4.746-5.625-9.219a5.625 5.625 0 0 1 11.25 0c0 4.471-4.334 8.203-5.625 9.219Z"
    />
  </svg>
);
export default LocationIcon2;
